import apiClient from "./client";

// types/category.ts
export interface Category {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedCategoriesResponse {
  success: boolean;
  message: string;
  data: {
    data: Category[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const categoriesApi = {
  // Get all categories with pagination
  async getCategories(params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): Promise<PaginatedCategoriesResponse> {
    const response = await apiClient.get<PaginatedCategoriesResponse>('/categories', { params });
    return response.data;
  },

  // Get single category by ID
  async getCategoryById(id: string): Promise<{ success: boolean; data: Category }> {
    const response = await apiClient.get<{ success: boolean; data: Category }>(`/categories/${id}`);
    return response.data;
  },

  // Create new category
  async createCategory(data: { name: string; isActive?: boolean }): Promise<{ success: boolean;message: string, data: Category }> {
    const response = await apiClient.post<{ success: boolean; message: string, data: Category }>('/categories', data);
    return response.data;
  },

  // Update category
  async updateCategory(
    id: string,
    data: { name?: string; isActive?: boolean }
  ): Promise<{ success: boolean; message: string, data: Category }> {
    const response = await apiClient.patch<{ success: boolean; message: string, data: Category }>(`/categories/${id}`, data);
    return response.data;
  },

  // Update category status
  async updateCategoryStatus(
    id: string,
    data: { isActive: boolean }
  ): Promise<{ success: boolean; message: string, data: Category }> {
    const response = await apiClient.patch<{ success: boolean; message: string, data: Category }>(
      `/categories/${id}/status`,
      data
    );
    return response.data;
  },

  // Soft delete category
  async deleteCategory(id: string): Promise<{ success: boolean; message: string, data: Category }> {
    const response = await apiClient.patch<{ success: boolean; message: string, data: Category }>(
      `/categories/${id}/delete`
    );
    return response.data;
  }
};